import React, { useEffect } from 'react';

import ErrorScreen from 'components/shared/ErrorScreen';

function NotFoundWrapper({ onRetry }) {
  useEffect(() => {
    const interval = setInterval(() => {
      onRetry();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return <ErrorScreen status="404_guest" />;
}

export default NotFoundWrapper;
